/* Reducers: */
const getNextImage = (list, activeIndex, direction) => {
  const length = list.length;
  if (direction === 'next') {
    if (activeIndex < length - 1) {
      return Object.assign({}, list[activeIndex + 1], { url: list[activeIndex + 1].image });
    }
    return Object.assign({}, list[0], { url: list[0].image });
  } else if (direction === 'prev' && activeIndex > 0) {
    return Object.assign({}, list[activeIndex - 1], { url: list[activeIndex - 1].image });
  }
  return Object.assign({}, list[length - 1], { url: list[length - 1].image });
};

const modals = (state = {
  all: [],
  url: '',
  alt: '',
  caption: '',
  active: false,
}, action) => {
  const { type, payload, direction } = action;
  switch (type) {
    case 'UPDATE_MODAL_IMAGES':
      return { ...state, ...payload };
    case 'UPDATE_MODAL_IMAGE':
      return { ...state, ...payload, active: true };
    case 'CHANGE_MODAL_IMAGE': // eslint-disable-line no-case-declarations
      const indexOfActive = state.all.findIndex(item => item.image === state.url);
      const nextImage = getNextImage(state.all, indexOfActive, direction);
      return { ...state, ...nextImage };
    case 'CLOSE_MODAL':
      return { ...state, ...payload, active: false };
    default:
      return state;
  }
};

export default modals;

/* Selectors: */
export const getModalImage = state => state;



// WEBPACK FOOTER //
// ./js/reducers/modal.js